import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { removeMemberAsAdmin } from '../../services/updateMemberStatus'

export default function RemoveAsCoOwnerOverlay({ overlay, member, groupId, onRemoveAdmin }) {
  const [t] = useTranslation()
  const [loading, setLoading] = useState(false)
  const isCurrent = useRef(true)

  useEffect(() => {
    isCurrent.current = true
    return () => {
      isCurrent.current = false
    }
  })
  const onClick = () => {
    setLoading(true)
    removeMemberAsAdmin(groupId, member.memberCisId)
      .then(() => {
        onRemoveAdmin()
        overlay.close()
        return undefined
      })
      .catch((e) => {
        isCurrent.current && setLoading(false)
        console.error(e)
      })
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('group-management.remove-name-co-owner.heading', { name: member.userProfileName })}
    >
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="cancel-remove-co-owner-button" onClick={overlay.close}>
            {t('common-ui:cancel.action')}
          </Button>
          <Button
            data-testid="remove-co-owner-button"
            emphasis="medium"
            disabled={loading}
            onClick={onClick}
            Icon={loading ? NoticeLoading : undefined}
          >
            {t('common-ui:remove.action')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
